import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { DetailDrawerType } from '@lexplus-shared-lib';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../../localized-user-routes-const';
import { UserDetailDrawerTypeKey } from '../../../global/models/user-detail-drawer-type-key.model';
import { COMPLIANCE_PERMISSIONS } from './build-anforderung-detail-drawer-type.function';

/**
 * An Erlass as the detail drawer shows it, behind the same permissions as the Compliance Übersicht.
 * Its requirements and the Aufgaben raised against the Erlass itself are worked on, so they open a
 * level below it; its documents are only looked at, so they stack over it.
 *
 * @param {string} locale - The base language, which localizes the segment
 * @returns {DetailDrawerType} The Erlass's definition for the drawer
 */
export function buildErlassDetailDrawerType(locale: string): DetailDrawerType<UserDetailDrawerTypeKey> {
  return {
    segment: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.ERLASSE][locale],
    label: $localize`:@@common.erlass:Erlass`,
    drawerLabel: $localize`:@@compliance.erlassDrawer.label:Erlass-Details`,
    loadComponent: () => import('../pages/erlass-detail-page/erlass-detail-page.component').then((m) => m.ErlassDetailPageComponent),
    canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
    data: { requiredAnyPermission: COMPLIANCE_PERMISSIONS },
    contains: ['anforderung', 'aufgabe'],
    stacks: ['dokument'],
  };
}
